<template>
<div>
    <div class="form-inline">
        <input type="text" size="30" class="form-control form-control-sm mb-2"  v-model="term">               
        <button type="submit" class="btn btn-sm btn-primary ml-3 mb-2" @click="search">Search</button>
        <button class="btn btn-sm btn-warning ml-3 mb-2" @click="skip">Skip</button>
    </div>

    <div class="row">
        <div class="col-md-12">
            <table class="table table-sm">
                <tr v-for="(result,index) in results" v-bind:key="index">
                    <td><button class="btn btn-xs btn-primary" @click="getArtistAlbums(result.artistId,result)">Songs</button></td>
                    <td>{{result.artistName}}
                    <td>{{result.primaryGenreName}}</td>
                    <!-- <td><a :href="result.artistLinkUrl"  class="btn btn-xs btn-primary">iTunes</a></td> -->
                    <td>
                        <!-- <span class="badge badge-primary ml-3" v-if="result == selectedArtist">Selected</span> -->
                        <button class="btn btn-xs btn-primary" @click="setArtistId(result)">Set</button>
                    </td>
                </tr>
            </table>
        </div>
    </div>

    <div class="row">
        <div class="col-md-12 py-2" v-for="(album,index) in fuckJS" v-bind:key="index">
            <span v-if="album.wrapperType == 'track'">
                <button class="btn btn-xs btn-primary" @click="setTrackId(album)">Set</button>&nbsp;&nbsp;&nbsp;{{ album.trackCensoredName }}
            </span>
        </div>
    </div>

</div>
</template>


<script>
    const jsonp = require('jsonp');

    import {Howl, Howler} from 'howler';

    export default {
        mounted() {
            console.log('Artists Search mounted.')
        },

        props: ['artist'],

        data(){

            return {
                term: this.artist.name,
                type:'name',
                country: 'US',
                media: 'music', // movie, podcast, music, musicVideo, audiobook, shortFilm, tvShow, software, ebook, all 
                entity: 'musicArtist', // musicArtist, musicTrack, album, musicVideo, mix, song ////  entity=allArtist&attribute=allArtistTerm
                attribute: 'allArtistTerm', // mixTerm, genreIndex, artistTerm, composerTerm, albumTerm, ratingIndex, songTerm 
                results: [],
                albums: [],
                
                sortedalbums: [],
                selectedArtist: null,
            }
        },

        computed: {
            apiURL(){
                if(this.type === 'name'){
                    return this.searchURL;
                }
                if(this.type === 'iTunes Id'){
                    return this.itunesLookupURL;
                }
                if(this.type === 'AMG ID'){
                    return this.amgLookupURL;
                }
            },

            searchURL(){
                let url = 'https://itunes.apple.com/search?term=' + this.term;
                if(this.entity != ''){
                    url = url + '&entity=' + this.entity;
                }
                if(this.attribute != ''){
                    url = url + '&attribute=' + this.attribute;
                }
                return encodeURI(url).replace(/%20/g,"+");
            },

            itunesLookupURL(){
                return 'https://itunes.apple.com/lookup?id=' + this.term;
            },

            amgLookupURL(){
                return 'https://itunes.apple.com/lookup?amgArtistId=' + this.term;
            },

            fuckJS(){
               return this.albums.sort((a,b) => (a.trackCensoredName > b.trackCensoredName) ? 1 : ((b.trackCensoredName > a.trackCensoredName) ? -1 : 0)); 
            },

        },

        methods: {

            search(){
                let vm = this;
                jsonp(this.searchURL , null, (err, data) => {
                    if (err) {
                        console.error(err.message);
                    } else {
                        console.log(data);
                        vm.results = data.results;
                    }
                });
            },
            
            skip(){
                axios.patch('/admin/artists/' + this.id, {
                    id: null,
                    artistId: null,
                    artistLinkUrl:null,
                    artistName:null,
                    amgArtistId:null,
                    unlisted:true
                })
                .then(function (response) {
                    console.log(response);
                    window.location = '/admin/artists';
                })
                .catch(function (error) {
                    console.log(error);
                });
            },

            setTrackId(album){
                let vm = this;
                axios.patch('/admin/songs/' + this.song_id,album )
                .then(function (response) {
                    // console.log(response);
                    vm.setArtistId();
                })
                .catch(function (error) {
                    console.log(error);
                });
            },

            setArtistId(){
                let vm = this;
                axios.patch('/admin/artists/' + this.id, {
                    artistId: this.selectedArtist.artistId,
                    artistLinkUrl:this.selectedArtist.artistLinkUrl,
                    artistName:this.selectedArtist.artistName,
                    amgArtistId:this.selectedArtist.amgArtistId,
                    unlisted:false
                })
                .then(function (response) {
                    console.log(response);
                    window.location = '/admin/artists';
                })
                .catch(function (error) {
                    console.log(error);
                });
            },

            resetForm(){
                this.term = '';
                this.entity = '';
                this.attribute= '';
            },


            getArtistAlbums(id,artist){
                let vm = this;
                this.selectedArtist = artist;
                jsonp('https://itunes.apple.com/lookup?id=' + id + '&entity=song', null, (err, data) => {
                    if (err) {
                        console.error(err.message);
                    } else {
                        console.log(data);
                        vm.albums = data.results;
                    }
                });
            },

            play(file_path){
                var sound = new Howl({
                    src: file_path,
                    volume: 0.5,
                });
                sound.play();
            },

            loadName(){
                this.term = this.name;
                this.search();
            }

        }

}



    
</script>
